import React, { Component, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Modal, Accordion, Card } from "react-bootstrap";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import { AdminService } from "../../../services/admin-service";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import { ToastContainer } from "react-toastify";

export const Content = (props) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email");
  const history = useHistory();
  const [submitloading, setSubmitLoading] = useState(true);

  const handleResend = async (e) => {
    e.preventDefault();
    try{
      await AdminService.adminForgotPassword(email);
      notify("Successfully Send OTP Code");
    }catch(e){
      notifyWarning("OTP Sent Failed");
    }
    
  }

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
      setSubmitLoading(false);
    try {
      await AdminService.adminValidateOTP(email, values.otp);

      setSubmitLoading(true);
      notify("Successfully Validate OTP");
      history.replace(`/password-reset-set-password?email=` + email)
    } catch (err) {
      notifyWarning("OTP Validation Failed");
      setSubmitLoading(true);
    }
  };

  return (
    <div className="ms-content-wrapper ms-auth">
      <div>
        <ToastContainer />
      </div>
      <div className="ms-auth-container">
        <div className="ms-auth-col">
          <div className="ms-auth-bg" />
        </div>
        <div className="ms-auth-col">
          <div className="ms-auth-form">
            <Formik
              initialValues={{
                otp: "",
              }}
                validationSchema={Yup.object().shape({
                  otp: Yup.string().required("Required"),
                    
                })}

              onSubmit={onSubmitForm}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                touched,
                values,
                submitForm,
                isValid,
              }) => (
                <form>
                  <h3>Validate OTP</h3>
                  <p>Enter OTP code received to your email. Please await couple of minutes to arrive the OTP Email.</p>
                  <div className="mb-3">
                    <label htmlFor="validationCustom08">OTP</label>
                    <div className="input-group">
                    <input
                      type="text"
                      name="otp"
                      className="form-control"
                      id="validationCustom08"
                      maxLength="6"
                      pattern="\d*"
                      inputMode="numeric"
                      placeholder="123456"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    </div>
                    <div style={{ color: "red", fontSize: "12px" }}>
                      {touched.otp && errors.otp}
                    </div>
                  </div>
                  <div>
                  <p className="mb-0 mt-3 text-center">
                    <Link className="btn-link" to="" onClick={(e) => {handleResend(e)}}>
                    Resend OTP Code
                    </Link>
                  </p>
                  </div>
                  <div className="col-md-2" hidden={submitloading}>
                    <div className="spinner spinner-7">
                      <div className="bounce1" />
                      <div className="bounce2" />
                      <div className="bounce3" />
                    </div>
                  </div>
                  <button
                    className="btn btn-primary mt-4 d-block w-100"
                    type="button"
                    onClick={submitForm}
                  >
                    Validate
                  </button>
                  <p className="mb-0 mt-3 text-center">
                    Go Back{" "}
                    <Link className="btn-link" to="/login">
                      Login
                    </Link>
                  </p>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
